import DefaultElementNodeType from '../DefaultElementNodeType';
import {PHYSICAL_DISTRIBUTION_NETWORK} from '../../metamodel/Concept';

export default class DistributionNetworkNodeType extends DefaultElementNodeType {
	static get typeName() {
		return PHYSICAL_DISTRIBUTION_NETWORK;
	}
}
